import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { Row, Col, Card, CardHeader, CardBody, FormGroup, Input, Label, Button } from 'reactstrap';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import moment from 'moment';
import md5 from 'md5';

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

import TicketsEditor from '../Tickets/Editor';

import Lang from '../../languages';
import Config from '../../config';

import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import './List.css';

class ProductsView extends Component {
 constructor(props) {
  super(props);

  this.state = {
   page: 1,
   data: [],
   totalSize: 0,
   sizePerPage: 5,
   sortOrder: 'asc',
   sortField: 'start_date',
   editorWindow: false,
   selected: [],
   selectedEvent: null,
   finished: false,
   products: {}
  };

  moment.locale(Lang[this.props.session.language].locale);

  this.columns = [
   { dataField: 'start_date', text: Lang[this.props.session.language].Products.columns.start_date, formatter: (cellContent, row) => { return moment(cellContent).format(Lang[this.props.session.language].fullDatetimeFormat); }, sort: true },
   {
    text: '',
    sort: true,
    dataField: 'bookings',
    headerStyle: () => { return { width: '55%', fontSize: 8 } },
    headerFormatter: () => {
     return (
      <div>
       <Row>
        <Col xs="4"><strong>{Lang[this.props.session.language].Tickets.titles.editorTab1}</strong></Col>
        <Col xs="2" className="text-right pr-0"><strong>{Lang[this.props.session.language].Products.columns.tickets.stock}</strong></Col>
        <Col xs="3" className="text-right pr-0"><strong>{Lang[this.props.session.language].Tickets.title}</strong></Col>
        <Col xs="3" className="text-right pr-0"><strong>{Lang[this.props.session.language].Tickets.columns.stockLeft}</strong></Col>
       </Row>
      </div>
     )
    },
    formatter: (cellContent, row) => {
     return (
      <div>
       {
        row.tickets ? row.tickets.map((item, key) => {
         return <Row key={key}>
          <Col xs="5"><small>{item.name[this.props.session.language]}</small></Col>
          <Col xs="2"><small>{item.stock}</small></Col>
          <Col xs="3" className="text-center"><small>{item.reserved ? item.reserved : '-'}</small></Col>
          <Col xs="2" className="text-center"><small>{item.reserved ? item.stock - item.reserved : '-'}</small></Col>
         </Row>
        }) : null
       }
      </div>
     )
    }
   },
   {
    dataField: 'ID', text: '', headerStyle: () => { return { width: '60px' } }, formatter: (cellContent, row) => {
     return (
      <div className="checkbox disabled">
       {
        row.status > 0 ?
         this.props.session.permissions.controllers.tickets.find(el => el == 'create') ?
          <Button color="success" onClick={() => this.openEditor(row.ID)}><i className="fa fa-ticket"></i></Button>
          : null
         : null
       }
      </div>
     )
    }
   }
  ];

  this.openEditor = this.openEditor.bind(this);
  this.closeEditor = this.closeEditor.bind(this);

  this.handleTableChange = this.handleTableChange.bind(this);
  this.forceTableChange = this.forceTableChange.bind(this);
 }


 handleTableChange(type, { page, sizePerPage, sortField, sortOrder }) {
  if (this.state.products)
   this.props.reqAPI(Config.apiURI + '/api/products/events', 'POST', { productID: this.state.products.ID, page, sizePerPage, sortField, sortOrder, finished: this.state.finished }).then(data => {
    this.setState(() => ({ page, data: data.items, totalSize: data.total, sizePerPage, sortField, sortOrder }));
   });
 }

 forceTableChange() {
  this.handleTableChange('reload', {
   page: this.state.page,
   sizePerPage: this.state.sizePerPage,
   filters: this.state.filters,
   sortField: this.state.sortField,
   sortOrder: this.state.sortOrder
  });
 }

 openEditor(ID) {
  if (ID === null) {
   this.setState({ selectedEvent: null }, function () {
    this.setState({ editorWindow: true });
   });
  } else {
   this.props.reqAPI(Config.apiURI + '/api/products/events/' + ID + '?full').then(event => {
    this.setState({ selectedEvent: event }, function () {
     this.setState({ editorWindow: true });
    });
   })
  }
 }

 closeEditor(state) {
  if (state) toast.success('Los cambios han sido guardados');
  this.setState({ selectedEvent: null, editorWindow: false });
  this.handleTableChange('reload', {
   page: this.state.page,
   sizePerPage: this.state.sizePerPage,
   sortField: this.state.sortField,
   sortOrder: this.state.sortOrder
  });
 }

 componentDidMount() {
  this.props.reqAPI(Config.apiURI + '/api/products/' + this.props.location.pathname.split('/')[2] + '?full').then(products => {
   this.setState({ products }, () => {
    this.handleTableChange('reload', {
     page: this.state.page,
     sizePerPage: this.state.sizePerPage,
     sortField: this.state.sortField,
     sortOrder: this.state.sortOrder
    });
   });
  });
 }


 render() {
  if (Object.keys(this.state.products).length > 0) {
   var description = this.state.products.description ?
    this.state.products.description[this.props.session.language]
     ? this.state.products.description[this.props.session.language].replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br />$2')
     : this.state.products.description[Config.defaultLanguage].replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br />$2')
    : null
   return (
    <Row>

     <Col md="7">
      <Card>
       <CardHeader>
        <div>
         <h4>{this.state.products.name[this.props.session.language]}</h4>
         <Link to={'/establishments/' + this.state.products.establishment}>{this.state.products.establishmentName}</Link>
        </div>
       </CardHeader>
       <CardBody dangerouslySetInnerHTML={{ __html: description }} />
       <CardHeader>
        <div className="fileContainer">
         <div className="uploadPicturesWrapper">
          {
           this.state.products.pictures ? this.state.products.pictures.map((picture, index) => {
            return (
             <div key={index} className="uploadPictureContainer">
              <img src={picture} className="uploadPicture" alt="preview" />
             </div>
            )
           }) : null
          }
         </div>
        </div>
       </CardHeader>
      </Card>
     </Col>

     <Col md="5">
      <Card>
       <div className="card-header pl-2 pt-2 pb-0 mb-3">
        <h5 className="float-left">{this.state.finished ? Lang[this.props.session.language].Events.title : Lang[this.props.session.language].Events.upcoming}</h5>
        <FormGroup className="float-right" check inline>
         <Input type="checkbox" checked={this.state.finished} onChange={(e) => { this.setState({ finished: e.target.checked }, this.forceTableChange) }} />
         <Label check>{Lang[this.props.session.language].Products.buttons.showFinished}</Label>
        </FormGroup>
       </div>

       <BootstrapTable
        remote
        striped
        condensed
        bootstrap4
        keyField="ID"
        bordered={false}
        data={this.state.data}
        columns={this.columns}
        defaultSorted={[{
         dataField: 'start_date',
         order: 'asc'
        }]}
        pagination={
         paginationFactory({
          page: this.state.page,
          sizePerPage: this.state.sizePerPage,
          sizePerPageList: [
           { text: '5', value: 5 },
           { text: '10', value: 10 },
           { text: '25', value: 25 },
           { text: '50', value: 50 },
           { text: '100', value: 100 }
          ],
          hideSizePerPage: true,
          showTotal: false,
          totalSize: this.state.totalSize,
          firstPageText: Lang[this.props.session.language].pagination.firstPageText,
          prePageText: Lang[this.props.session.language].pagination.prePageText,
          nextPageText: Lang[this.props.session.language].pagination.nextPageText,
          lastPageText: Lang[this.props.session.language].pagination.lastPageText,
          firstPageTitle: Lang[this.props.session.language].pagination.firstPageTitle,
          nextPageTitle: Lang[this.props.session.language].pagination.nextPageTitle,
          prePageTitle: Lang[this.props.session.language].pagination.prePageTitle,
          lastPageTitle: Lang[this.props.session.language].pagination.lastPageTitle,
          paginationTotalRenderer: (from, to, size) => (
           <span className="react-bootstrap-table-pagination-total" dangerouslySetInnerHTML={{ __html: '&nbsp;' + Lang[this.props.session.language].paginationFooter(from, to, size) + ' ' + Lang[this.props.session.language].Products.name }} />
          )
         })
        }
        onTableChange={this.handleTableChange}
        noDataIndication={Lang[this.props.session.language].tableEmpty}
       />

       <TicketsEditor {...this.props} open={this.state.editorWindow} event={this.state.selectedEvent} handleClose={this.closeEditor} onComplete={this.closeEditor} />
      </Card>
     </Col>

    </Row>
   )
  } else {
   return (<Card />)
  }
 }
}

export default ProductsView;



// WEBPACK FOOTER //
// ./websources/views/Products/View.js